module.exports = __webpack_public_path__ + "empty_share.0b9b47b568306df70730266ec0e309ec.svg";